import { createElement, type ComponentType } from 'react';
import { BlockKeys } from '@data/Simulations/pipeline/BlockCatalog';
import { SpacingWidth01 as ThresholdIcon } from '@untitledui-pro/icons/line';
import { ParagraphSpacing as MapIcon } from '@untitledui-pro/icons/line';
import { DistributeSpacingHorizontal as NoOverhangIcon } from '@untitledui-pro/icons/line';
import { ArrowCircleBrokenDownLeft as UnobstructedIcon } from '@untitledui-pro/icons/line';
import { Cube03 as SliceIcon } from '@untitledui-pro/icons/line';
import { Skew as SlicePolygonIcon } from '@untitledui-pro/icons/line';
import { Grid01 as NoAloneIcon } from '@untitledui-pro/icons/line';
import { Calculator as AveragesIcon } from '@untitledui-pro/icons/line';
import { ArrowSquareUpRight as ProjectionIcon } from '@untitledui-pro/icons/line';
import { AlignRight01 as CloseToProjectIcon } from '@untitledui-pro/icons/line';
import { AlignBottom01 as CloseToTerrainIcon } from '@untitledui-pro/icons/line';
import { Sunset as PVSupplyIcon } from '@untitledui-pro/icons/line';
import { HomeLine as SolarHeatGainsIcon } from '@untitledui-pro/icons/line';

export type PipelineMenuBlockConfig = {
    type: BlockKeys;
    Icon: ComponentType<{ className?: string }>;
};

export type PipelineMenuEntry = PipelineMenuBlockConfig | 'divider';

const RotatedMapIcon: ComponentType<{ className?: string }> = ({ className }) =>
    createElement(MapIcon, { className, style: { transform: 'rotate(90deg)' } });

export const PIPELINE_MENU_LAYOUT: PipelineMenuEntry[] = [
    { type: BlockKeys.Threshold, Icon: ThresholdIcon },
    { type: BlockKeys.Map, Icon: RotatedMapIcon },
    { type: BlockKeys.Unobstructed, Icon: UnobstructedIcon },
    'divider',
    { type: BlockKeys.Slice, Icon: SliceIcon },
    { type: BlockKeys.InsidePolygon, Icon: SlicePolygonIcon },
    { type: BlockKeys.NoBase, Icon: NoOverhangIcon },
    { type: BlockKeys.Alone, Icon: NoAloneIcon },
    'divider',
    { type: BlockKeys.Averages, Icon: AveragesIcon },
    { type: BlockKeys.Projection, Icon: ProjectionIcon },
    'divider',
    { type: BlockKeys.CloseToProjSketch, Icon: CloseToProjectIcon },
    { type: BlockKeys.CloseToTerrain, Icon: CloseToTerrainIcon },
    'divider',
    { type: BlockKeys.PvPotentials, Icon: PVSupplyIcon },
    { type: BlockKeys.ShgPotentials, Icon: SolarHeatGainsIcon },
];
